export default {
  name: "popAnimation",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.$emit("close");
    }
  }
};